export const USER_ACTION_TYPES = {
    LOG_IN: 'user/LOG_IN',
    LOG_OUT: 'user/LOG_OUT',
    AUTH_IS_READY: 'user/AUTH_IS_READY',
    SET_TEAM_INDEX: 'user/SET_TEAM_INDEX',
    UPDATE_ACTIVITY_LOG: 'user/UPDATE_ACTIVITY_LOG',
    UPDATE_RECENTLY_VIEWED: 'user/UPDATE_RECENTLY_VIEWED',
    SET_CARD_COUNT: 'user/SET_CARD_COUNT',
    UPDATE_TOKENS: 'user/UPDATE_TOKENS',
    SET_EMAIL_VERIFICATION_PENDING: 'user/SET_EMAIL_VERIFICATION_PENDING',
    SET_USER_CACHE: 'user/SET_USER_CACHE',
    CLEAR_USER_CACHE: 'user/CLEAR_USER_CACHE',
    RESET_USER_STATE: 'user/RESET_USER_STATE'
};